import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ApertureOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-aperture-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3.6 15h10.55"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7.395 7.534l2.416 7.438"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17.032 4.636l-4.852 3.526m-2.334 1.695l-1.349 .98"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20.559 14.51l-8.535 -6.201"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12.257 20.916l2.123 -6.533m.984 -3.028l.154 -.473"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};